import { render, staticRenderFns } from "./mobile-dropdown.vue?vue&type=template&id=5c63edd8"
import script from "./mobile-dropdown.vue?vue&type=script&lang=ts"
export * from "./mobile-dropdown.vue?vue&type=script&lang=ts"
import style0 from "./mobile-dropdown.vue?vue&type=style&index=0&id=5c63edd8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports